import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PriceConfig } from './components/PriceConfig';
import { PaymentPage } from './components/PaymentPage';
import { AdminPanel } from './components/AdminPanel';
import { PriceProvider } from './contexts/PriceContext';
import { EmailProvider } from './contexts/EmailContext';
export function AppRouter() {
  return <BrowserRouter data-id="element-55">
      <PriceProvider data-id="element-56">
        <EmailProvider data-id="element-57">
          <Routes data-id="element-58">
            <Route path="/" element={<App data-id="element-60" />} data-id="element-59" />
            <Route path="/config" element={<PriceConfig data-id="element-62" />} data-id="element-61" />
            <Route path="/admin" element={<AdminPanel data-id="element-64" />} data-id="element-63" />
            <Route path="/pay/:invoiceId" element={<PaymentPage data-id="element-66" />} data-id="element-65" />
          </Routes>
        </EmailProvider>
      </PriceProvider>
    </BrowserRouter>;
}